module.exports = __webpack_public_path__ + "static/media/unibestMv2.2669c73a.png";